import { render, staticRenderFns } from "./UserAnalysesInstruction3.vue?vue&type=template&id=47244c67&"
import script from "./UserAnalysesInstruction3.vue?vue&type=script&lang=js&"
export * from "./UserAnalysesInstruction3.vue?vue&type=script&lang=js&"
import style0 from "./UserAnalysesInstruction3.vue?vue&type=style&index=0&id=47244c67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports